import gql from 'graphql-tag';
import { useQuery } from '@apollo/react-hooks';

const QUERY_US = gql`
  query scaleRate(
    $projectId: Int!
    $startDate: String!
    $workState: String!
    $hireState: String!
    $workCity: String
    $hireCity: String
    $union: String!
    $occupation: String!
    $workSchedule: String!
    $season: Int
    $currency: String
  ) {
    scaleRate(
      projectId: $projectId
      startDate: $startDate
      workState: $workState
      hireState: $hireState
      workCity: $workCity
      hireCity: $hireCity
      union: $union
      occupation: $occupation
      workSchedule: $workSchedule
      season: $season
      currency: $currency
    ) {
      studioRatePerHour
      locationRatePerHour
      studioRatePerWeek
      locationRatePerWeek
      studioGuaranteedHours
      locationGuaranteedHours
      idleLocationSixthDayRatePerHour
      idleLocationSeventhDayRatePerHour
      overtimeRatePerHour
    }
  }
`;

const QUERY_CANADA = gql`
  query scaleRate(
    $projectId: Int!
    $startDate: String!
    $workState: String!
    $hireState: String!
    $workCity: String
    $hireCity: String
    $union: String!
    $occupation: String!
    $workSchedule: String!
    $season: Int
    $currency: String
  ) {
    scaleRate(
      projectId: $projectId
      startDate: $startDate
      workState: $workState
      hireState: $hireState
      workCity: $workCity
      hireCity: $hireCity
      union: $union
      occupation: $occupation
      workSchedule: $workSchedule
      season: $season
      currency: $currency
    ) {
      ratePerHour
      weeklyRate
      overtimeRatePerHour
    }
  }
`;

const QUERY_US_V2_WEEKLY = gql`
  query scaleRate(
    $projectId: Int!
    $startDate: String!
    $workState: String!
    $hireState: String!
    $workCity: String
    $hireCity: String
    $union: String!
    $occupation: String!
    $workSchedule: String!
    $season: Int
    $currency: String
  ) {
    scaleRateV2(
      projectId: $projectId
      startDate: $startDate
      workState: $workState
      hireState: $hireState
      workCity: $workCity
      hireCity: $hireCity
      union: $union
      occupation: $occupation
      workSchedule: $workSchedule
      season: $season
      currency: $currency
    ) {
      rate
      ... on TermsOfEmploymentUnionHourly {
        rateDistant
        guaranteedHours
        guaranteedHoursDistant
        weeklyRate
        weeklyRateDistant
      }
    }
  }
`;

const QUERY_US_V2 = gql`
  query scaleRate(
    $projectId: Int!
    $startDate: String!
    $workState: String!
    $hireState: String!
    $workCity: String
    $hireCity: String
    $union: String!
    $occupation: String!
    $workSchedule: String!
    $season: Int
    $currency: String
  ) {
    scaleRateV2(
      projectId: $projectId
      startDate: $startDate
      workState: $workState
      hireState: $hireState
      workCity: $workCity
      hireCity: $hireCity
      union: $union
      occupation: $occupation
      workSchedule: $workSchedule
      season: $season
      currency: $currency
    ) {
      rate
      ... on TermsOfEmploymentUnionHourly {
        rateDistant
        guaranteedHours
        guaranteedHoursDistant
      }
    }
  }
`;

const useScaleRates = variables => {
  const {
    projectId,
    countryCode,
    startDate,
    workState,
    hireState,
    workCity,
    hireCity,
    currency,
    union,
    isNonUnion = false,
    occupation,
    workSchedule,
    isUnionScheduleAV2,
    isUnionWeeklyScheduleV2,
  } = variables;

  let QUERY;
  if (countryCode === 'CA') {
    QUERY = QUERY_CANADA;
  } else if (isUnionScheduleAV2) {
    QUERY = QUERY_US_V2;
  } else if (isUnionWeeklyScheduleV2) {
    QUERY = QUERY_US_V2_WEEKLY;
  } else {
    QUERY = QUERY_US;
  }

  const skip =
    !projectId ||
    !startDate ||
    !workState ||
    !hireState ||
    (countryCode === 'US' && !workCity) ||
    (countryCode === 'US' && !hireCity) ||
    !currency ||
    !union ||
    isNonUnion ||
    !occupation ||
    !workSchedule;
  const { loading, data } = useQuery(QUERY, {
    skip,
    variables,
    notifyOnNetworkStatusChange: true,
  });
  let modifiedData;
  if (isUnionWeeklyScheduleV2 || isUnionScheduleAV2) {
    modifiedData = data?.scaleRateV2;
  } else {
    modifiedData = data?.scaleRate;
  }

  return {
    loading,
    data: !skip && data && { ...modifiedData },
  };
};

export default useScaleRates;
